/** @import { TElementSpecifier } from "@de-xima/xima-common-js-dom" */
import { changeStyleClass, toElements } from "@de-xima/xima-common-js-dom";
import { withIndex } from "@de-xima/xima-common-js-lang";

/**
 * Finds the first element with the given class name, if any.
 * @deprecated TODO: Move this to @de-xima/xima-common-js-dom
 * @param {string} className CSS class name to search for.
 * @returns {Element | undefined} First element with the given class name, if any.
 */
export function byCssClass(className) {
  return document.getElementsByClassName(className)[0] ?? undefined;
}

/**
 * Toggles between two different, alternative styles classes. For example, if classes `x`
 * and `y` are given: If the element currently has `x`, removes `x` and adds `y`;
 * otherwise removes `y` and add `x`.
 *
 * In case of conflicts (element has both classes or neither class), the presence
 * or absence of the first given class is given priority. After this method completes,
 * exactly one of the two given classes is present on the element.
 * @deprecated TODO: Move this to @de-xima/xima-common-js-dom
 * @param {TElementSpecifier<Element>} selector
 * @param {string} class1 First style class.
 * @param {string} class2 Second style class.
 */
export function toggleBetweenClasses(selector, class1, class2) {
  for (const element of toElements(selector)) {
    const hasClass1 = element.classList.contains(class1);
    changeStyleClasses(element, [class1, class2], [hasClass1 ? 1 : 0]);
  }
}

/**
 * Adds or removes a list of style classes from all given elements. For each class
 * in the given list, the classes at the given indices are added, and all other classes
 * are removed.
 * @deprecated TODO: Move this to @de-xima/xima-common-js-dom
 * @param {TElementSpecifier<Element>} selector
 * @param {string[]} classes CSS classes to add or remove.
 * @param {number[]} indices Indices of the classes to add, all other classes are removed.
 */
export function changeStyleClasses(selector, classes, indices) {
  for (const element of toElements(selector)) {
    for (const [cssClass, i] of withIndex(classes)) {
      changeStyleClass(element, cssClass, indices.indexOf(i) >= 0);
    }
  }
}
